const component = require('../component/component');

// Date-range filter. Library-agnostic: each end is a native picker provided by
// the theme's `datepicker` behaviour (native HTML5 in base, tempusDominus in
// metronic_8). Day granularity — the date_interval filter collapses intervals to
// Y-m-d bounds — so the picker is left as a plain date input (no time component).
const date_interval = Object.assign({}, component, {
    subelements: {
        start: null,
        end: null
    },
    minDate: false,
    maxDate: false,
    startOfTheWeek: 1,
    format: 'yyyy-MM-dd',
    locale: 'en',

    // Handles returned by hm.behaviors.datepicker.create() for each end.
    startHandle: false,
    endHandle: false,

    init: function () {
        component.init.call(this);

        let commonOpts = {
            minDate: this.minDate === false ? false : this.minDate,
            maxDate: this.maxDate === false ? false : this.maxDate,
            format: this.format,
            locale: this.locale,
            startOfTheWeek: this.startOfTheWeek
        };

        if (this.subelements.start !== null) {
            this.startHandle = this.hm.behaviors.datepicker.create(this.subelements.start, commonOpts);
        }
        if (this.subelements.end !== null) {
            this.endHandle = this.hm.behaviors.datepicker.create(this.subelements.end, commonOpts);
        }

        // Cross-link the two ends: picking a start raises the end's minimum, and
        // picking an end lowers the start's maximum (so the range stays valid).
        if (this.subelements.start !== null && this.endHandle !== false) {
            this.subelements.start.addEventListener('change', () => {
                this.endHandle.setMin(this.startHandle.getValue());
            });
        }
        if (this.subelements.end !== null && this.startHandle !== false) {
            this.subelements.end.addEventListener('change', () => {
                this.startHandle.setMax(this.endHandle.getValue());
            });
        }
    },

    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }

        let value = {};
        if (this.startHandle !== false) {
            value.start = this.startHandle.getValue();
        }
        if (this.endHandle !== false) {
            value.end = this.endHandle.getValue();
        }

        return value;
    },

    formPostData: function (formPostData) {
        if (this.subelements.start !== null && this.startHandle !== false) {
            formPostData = this.hm.helper.formPostData(formPostData, this.subelements.start.name, this.startHandle.getValue());
        }

        if (this.subelements.end !== null && this.endHandle !== false) {
            formPostData = this.hm.helper.formPostData(formPostData, this.subelements.end.name, this.endHandle.getValue());
        }

        return formPostData;
    }
});

module.exports = date_interval;
